<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
          結果
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">結果</a>
          </li>
      </ul>
    </div>
    <b-card>
      <b-row>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-form inline>
              <span class="mr-2">検索範囲</span>
              <date-picker v-if="i18n" @change="$refs._list && $refs._list.refresh()" v-model="so.created_at_sd" style="width: 140px" :lang="custom.lang[i18n ? i18n.toLowerCase() : 'en']" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker v-if="i18n" @change="$refs._list && $refs._list.refresh()" v-model="so.created_at_ed" style="width: 140px" :lang="custom.lang[i18n ? i18n.toLowerCase() : 'en']" :confirm="false" :first-day-of-week="1"></date-picker>

              <b-btn class="btn-insert ml-2" @click="() => { so.created_at_sd = moment().add(-1, 'day'); $refs._list.refresh() }" size="sm" variant="info">-1</b-btn>
              <b-btn class="btn-insert ml-2" @click="() => { so.created_at_sd = moment().add(-7, 'day'); $refs._list.refresh() }" size="sm" variant="info">-7</b-btn>
              <b-btn class="btn-insert ml-2" @click="() => { so.created_at_sd = moment().add(-30, 'day'); $refs._list.refresh() }" size="sm" variant="info">-30</b-btn>
            </b-form>
          </b-input-group>
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || '検索'"  size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='agent.name';so.skt='Agent Name'">エージェント名</b-dropdown-item>
                <!-- <b-dropdown-item size="sm" @click="so.sk='agent.ip_addr';so.skt='Agent IP'">エージェント IP</b-dropdown-item> -->
                <b-dropdown-item size="sm" @click="so.sk='agent.ip_addr_public';so.skt='Agent Public IP'">エージェントパブリック IP</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='agent.ip_addr_private';so.skt='Agent Private IP'">エージェントプライベート IP</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='agent.host';so.skt='Host Name'">ホスト名</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" class="table-responsive table_add"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="agent" slot-scope="row" v-if="row.item.agent">
          <span v-if="row.item.agent.name == row.item.agent.host">
            {{row.item.agent.host}}@{{row.item.agent.ip_addr_public}}

            <span v-if="row.item.agent.ip_addr_private != row.item.agent.ip_addr_public">
              ({{row.item.agent.ip_addr_private}})
            </span>
          </span>
          <span v-else>
            {{row.item.agent.name}} ({{row.item.agent.host}}@{{row.item.agent.ip_addr_public}})
            <span v-if="row.item.agent.ip_addr_private != row.item.agent.ip_addr_public">
              ({{row.item.agent.ip_addr_private}})
            </span>
          </span>
        </template>
        <template slot="scan_folder" slot-scope="row">{{row.item.scan_folder | number}} フォルダー</template>
        <template slot="scan_count" slot-scope="row">{{row.item.scan_count | number}} ファイル </template>
        <template slot="detect_count" slot-scope="row">
          <span v-if="row.item.detect_count">
            {{ row.item.detect_count | number }}
          </span>
          <span v-else>
            -
          </span>
        </template>
        <template slot="scan_time" slot-scope="row">
          <a href="javascript:void(0)" class="a_tag" @click="detail(row.item)">
            {{row.item.scan_time | datetime}}
            ({{row.item.scanning_time}})
          </a>
        </template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" :variant="row.item.detect_count ? 'danger' : 'outline-primary'">確認</b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm"  align="center" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
        </b-col>
      </b-row>
    </b-card>

    <!-- 시작 및 마지막 날짜 유무 확인 모달-->
    <b-modal title="検索範囲の設定" size="xs" v-model="date_modal" @ok="date_modal = false" ok-variant="outline-primary" ok-only>
      開始日と終了日を指定してください。
    </b-modal>

    <!-- 기간 설정 범위제한 모달-->
    <b-modal title="検索範囲の設定" size="xs" v-model="year_modal" @ok="year_modal = false" ok-variant="outline-info" ok-only>
      結果一覧は最大1年単位で閲覧できます。
    </b-modal>

    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
